module.exports = __webpack_public_path__ + "img/HPS020NG.6a0e9072.png";